import React from 'react';
import { Users, Briefcase, Check } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { fleet } from '../mock';

const Fleet = () => {
  return (
    <section id="fleet" className="py-24 bg-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Our Executive <span className="text-amber-500">EV Fleet</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Immaculate luxury electric vehicles maintained to the highest standards.
            Zero emissions, maximum comfort.
          </p>
        </div>

        {/* Fleet Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {fleet.map((vehicle) => (
            <Card
              key={vehicle.id}
              className="bg-slate-900 border-slate-700 overflow-hidden group hover:border-amber-500/50 transition-all duration-300 hover:shadow-2xl hover:shadow-amber-500/20"
            >
              {/* Vehicle Image */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={vehicle.image}
                  alt={vehicle.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-transparent to-transparent"></div>
                <Badge className="absolute top-4 right-4 bg-amber-500 text-black font-semibold">
                  {vehicle.category}
                </Badge>
              </div>

              <CardContent className="p-6">
                {/* Vehicle Name */}
                <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-amber-500 transition-colors">
                  {vehicle.name}
                </h3>

                {/* Capacity */}
                <div className="flex items-center gap-6 mb-4 text-gray-300">
                  <div className="flex items-center gap-2">
                    <Users className="w-5 h-5" />
                    <span>{vehicle.passengers} Passengers</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Briefcase className="w-5 h-5" />
                    <span>{vehicle.luggage} Luggage</span>
                  </div>
                </div>

                {/* Features */}
                <div className="space-y-2">
                  {vehicle.features.map((feature, index) => (
                    <div key={index} className="flex items-center gap-2 text-gray-200">
                      <Check className="w-4 h-4 text-amber-500" />
                      <span className="text-sm">{feature}</span>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Fleet;